import { createContext} from 'react'

export const BaseballContext = createContext()

 

